import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogBusiness } from "../../../../store/catalog/actions";
export var useGetCatalogGender = function (trigger) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalog: (_a = state.Catalog.responseCatalogBusiness) === null || _a === void 0 ? void 0 : _a.data,
            loadingGetCatalog: state.Catalog.loadingCatalogBusiness,
            errorGetCatalog: state.Catalog.errorCatalogBusiness,
        });
    }), responseGetCatalog = _a.responseGetCatalog, loadingGetCatalog = _a.loadingGetCatalog, errorGetCatalog = _a.errorGetCatalog;
    useEffect(function () {
        if (trigger) {
            dispatch(getCatalogBusiness({
                enable: true,
                page: 1,
                limit: 1000,
                type: "CATALOG_SEXO",
            }));
        }
    }, [trigger]);
    return {
        responseGetCatalog: responseGetCatalog,
        loadingGetCatalog: loadingGetCatalog,
        errorGetCatalog: errorGetCatalog,
    };
};
